






import Vue from 'vue';
import PageFetchHook from '@/components/mixins/PageFetchHook';
import store from '@/store';
import * as CvSectionProfileStore from '@/containers/cv-section-profile/store';
import EditContainer from '@/containers/cv-section-profile/edit.vue';

const fetch = async params => {
  const { cv_id } = params;
  await store.dispatch(
    CvSectionProfileStore.GetCvSectionProfile.namespaced({ cv_id })
  );
};

export default Vue.extend({
  // NOTE: DO NOT reset state of CvSectionProfileStore because it will be used in sections
  components: {
    EditContainer,
  },
  mixins: [PageFetchHook(fetch)],
});
